var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.292a7.708 7.708 0 1 0 0 15.416 7.708 7.708 0 0 0 0-15.416ZM1.04 10a8.958 8.958 0 1 1 17.917 0A8.958 8.958 0 0 1 1.04 10Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.042 2.5c0-.345.28-.625.625-.625H7.5a.625.625 0 0 1 .593.823 23.061 23.061 0 0 0 0 14.604.625.625 0 0 1-.593.823h-.833a.625.625 0 0 1-.018-1.25 24.313 24.313 0 0 1 0-13.75.625.625 0 0 1-.607-.625ZM12.302 1.907a.625.625 0 0 1 .791.395 24.311 24.311 0 0 1 0 15.396.625.625 0 0 1-1.186-.396 23.061 23.061 0 0 0 0-14.604.625.625 0 0 1 .395-.79Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.135 11.993a.625.625 0 0 1 .563-.086 23.061 23.061 0 0 0 14.604 0 .625.625 0 0 1 .823.593v.833a.625.625 0 0 1-1.25.018 24.314 24.314 0 0 1-13.75 0 .625.625 0 0 1-1.25-.018V12.5c0-.201.097-.39.26-.507ZM17.302 8.093a23.061 23.061 0 0 0-14.604 0 .625.625 0 0 1-.396-1.186 24.311 24.311 0 0 1 15.396 0 .625.625 0 0 1-.396 1.186Z",
    fill: "#123862"
  })));
};
export default SvgLanguage;